import eventHub from './index'

// Trigger events on HTML click
document.addEventListener('click', function() {
  eventHub.$emit('tooltips:close')
})
